import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {BadgeComponent} from "../badge/badge.component";


@Component({
    selector: 'app-badge-with-content',
    imports: [
    BadgeComponent
],
    templateUrl: './badge-with-content.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './badge-with-content.component.scss'
})
export class BadgeWithContentComponent extends BadgeComponent {
  @Input() public header: string = '';
  @Input() public center: boolean = false;
  @Input() public content: string | number | undefined | null = '';
}
